import {
  ArchiveCodeBookMutation,
  ArchiveCodeBookMutationVariables,
  CreateCodeBookMutation,
  CreateCodeBookMutationVariables,
  GetCodeBooksQuery,
  GetCodeBooksQueryVariables,
  UpdateCodeBookMutation,
  UpdateCodeBookMutationVariables,
} from '../../types/graphql'
import { useMyOrgId } from '../layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from '../utils/queryClient'

const CreateMutation = gql`
  mutation CreateCodeBookMutation($input: CreateCodeBookInput!) {
    createCodeBook(input: $input) {
      id
    }
  }
`

export const useCreateCodeBookMutation = () => {
  return useMutation<CreateCodeBookMutation, CreateCodeBookMutationVariables>({
    mutationDocument: CreateMutation,
  })
}

const Get = gql`
  query GetCodeBooksQuery($input: GetCodeBooksInput) {
    codeBooks(input: $input) {
      ...CodeBookFragment
    }
  }
`

export const useCodeBooksQuery = () => {
  const organizationId = useMyOrgId()
  return useQuery<GetCodeBooksQuery, GetCodeBooksQueryVariables>({
    queryKey: [QueryKey.CodeBooks, organizationId],
    queryDocument: Get,
    variables: { input: { organizationId } },
  })
}

const UpdateMutation = gql`
  mutation UpdateCodeBookMutation($id: Int!, $input: CreateCodeBookInput!) {
    updateCodeBook(id: $id, input: $input) {
      id
    }
  }
`

export const useUpdateCodeBookMutation = () => {
  return useMutation<UpdateCodeBookMutation, UpdateCodeBookMutationVariables>({
    mutationDocument: UpdateMutation,
  })
}

const ArchiveMutation = gql`
  mutation ArchiveCodeBookMutation($id: Int!) {
    archiveCodeBook(id: $id) {
      id
    }
  }
`

export const useArchiveCodeBookMutation = () => {
  return useMutation<ArchiveCodeBookMutation, ArchiveCodeBookMutationVariables>({
    mutationDocument: ArchiveMutation,
  })
}
